export const muvi = {
  hero: {
    title1: 'MuVi Space',
    title2: 'Create.',
    title3: 'Record.',
    title4: 'Broadcast.',
    subtitle: 'ポッドキャスト、ライブ配信、キャスティング、ブランドインタビュー、ショート動画制作空間',
    cta: '今すぐ予約',
  },
  features: {
    title: 'スペースの特徴',
    subtitle: 'スマホやカメラ一台で創作を始められる',
    podcast: { title: 'Podcast 収録', desc: '防音完備の空間でマルチトラック録音対応。二人対談から円卓形式まで柔軟に対応。' },
    livestream: { title: 'ライブ配信', desc: '安定した高速ネット回線とマルチカメラ切り替え設備、主要配信プラットフォームに対応。' },
    casting: { title: 'キャスティング空間', desc: '専用オーディションエリア。プロ仕様の照明とモニタリングシステム完備。' },
    productShooting: { title: '商品撮影', desc: '広々とした無限壁とターンテーブル撮影台。EC素材制作にも最適。' },
    interview: { title: 'ブランドインタビュー', desc: '快適なインタビューセット。自然光とプロ照明の融合で印象的なブランド映像を演出。' },
    workshop: { title: 'ワークショップ / セミナー', desc: '15〜20名収容のフレキシブル空間。小規模セミナーや研修に最適。' },
  },
  gallery: {
    title: '施設ギャラリー',
    subtitle: '多様なシーン、自在に変幻',
    podcast: 'Podcast スタジオ',
    livestream: 'ライブ配信ルーム',
    productShooting: '商品撮影エリア',
    interview: 'インタビュースペース',
    workshop: 'ワークショップエリア',
    casting: 'キャスティングゾーン',
  },
  equipment: {
    title: '機材とサービス',
    subtitle: '機材はプロジェクト内容に応じて確認し、店頭機材とレンタル資源を組み合わせて調整します',
    microphone: { title: 'プロフェッショナルマイク', desc: '主に RØDE、Shure などのプロ用マイクを想定し、実際の型番と数量は予約内容に応じて確認します。' },
    lighting: { title: '照明システム', desc: '主に Aputure、Godox、SIRUI などの映像用照明を想定し、シーンに応じてアクセサリーを調整します。' },
    liveStreaming: { title: 'ライブ配信機材', desc: 'ライブ配信・スイッチング機材は主に CINETREAK CineTreak C2 または ATEM を想定し、構成と利用可否は案件ごとに確認します。' },
    tripod: { title: '三脚・スタビライザー', desc: 'Manfrotto プロ三脚、DJI スタビライザーでスムーズな映像を実現。' },
    monitor: { title: 'モニター画面', desc: '複数のプレビューモニターで、監督やクライアントが構図と照明をリアルタイムに確認可能。' },
    switcher: { title: 'スイッチャー / コントロール機材', desc: 'スイッチャーやコントロール機材は主に CINETREAK CineTreak C2 または ATEM を想定し、実際の型番・数量・操作要件は予約内容に応じて確認します。' },
  },
  pricing: {
    title: '料金プラン',
    subtitle: '透明な価格設定、隠れた費用なし',
    venue: '会場費用',
    venuePrice: 'NT$500 / 時間',
    venueDesc: '基本照明、空調、Wi-Fi 込み',
    techSupport: '技術サポート',
    techPrice: 'NT$200 / 時間',
    techDesc: '専門技術スタッフが現場でサポート',
    note: '最低2時間からのご予約',
  },
  faq: {
    title: 'よくある質問',
    subtitle: 'MuVi Space に関するよくあるご質問',
    q1: '駐車場はありますか？',
    a1: 'MuVi Space は LensBank 店内にございます。周辺に有料駐車場と路上駐車スペースがあります。機材の積み下ろしの際は、入口での一時停車が可能です。',
    q2: 'Wi-Fi は利用できますか？',
    a2: '施設内では高速光ファイバー Wi-Fi をご利用いただけます。アップロード・ダウンロードともに 300Mbps 以上で、ライブ配信やファイル転送も安定しています。',
    q3: '深夜の利用は可能ですか？',
    a3: 'MuVi Space の標準営業時間は 09:00〜22:00 です。深夜利用をご希望の場合は、ご予約時にその旨をお知らせください。状況に応じて対応いたします（追加料金が発生する場合があります）。',
    q4: '自分の機材を持ち込めますか？',
    a4: 'もちろん可能です！ご自身のカメラや照明、音声機材を自由にお持ち込みいただけます。また、当社の機材レンタルサービスと組み合わせてのご利用もおすすめです。',
    q5: 'どのくらい前に予約すればよいですか？',
    a5: '会場とスタッフの手配のため、3営業日前までのご予約をおすすめします。お急ぎの場合はお電話にてご相談ください。',
    q6: '予約のキャンセルや変更はできますか？',
    a6: 'ご予約確定後の変更・キャンセルは、利用日の48時間前までにご連絡ください。当日キャンセルは50％の料金が発生します。',
    q7: '何名まで収容できますか？',
    a7: 'MuVi Space は約20坪で、2〜15名の撮影チームに最適です。より広いスペースや特殊なセットが必要な場合は、事前にご相談ください。',
    q8: 'ケータリングサービスはありますか？',
    a8: 'パントリーにコーヒー、紅茶、ミネラルウォーターをご用意しております。お食事のデリバリーやケータリングの手配も承ります。',
  },
  booking: {
    title: 'MuVi Space を予約',
    subtitle: '以下のフォームにご記入ください。確認後、ご連絡いたします',
    formTitle: '予約申込フォーム',
    companyName: '会社名',
    companyNamePlaceholder: '会社名または団体名を入力してください',
    contactName: 'ご担当者名',
    contactNamePlaceholder: 'ご担当者名を入力してください',
    phone: '電話番号',
    phonePlaceholder: '例：090-1234-5678',
    email: 'メールアドレス',
    emailPlaceholder: 'example@company.com',
    activityType: '活動タイプ',
    activityTypePlaceholder: '活動タイプを選択してください',
    date: '希望日',
    startTime: '開始時間',
    endTime: '終了時間',
    needTechSupport: '技術サポートは必要ですか？',
    needTechSupportYes: '必要（+NT$200/時間）',
    needTechSupportNo: '不要',
    notes: '備考',
    notesPlaceholder: '特別なご要望がございましたら、こちらにご記入ください（必要な機材、会場設営のご希望など）...',
    notesMaxChars: '最大500文字',
    pricingSummary: '見積費用',
    venueFee: '会場費用',
    techFee: '技術サポート費用',
    hours: '時間',
    total: '合計',
    submitButton: '予約申込を送信',
    submitting: '送信中...',
    noticeTitle: '重要なお知らせ',
    noticeText: '送信後は予約申込となります。予約成立には MuVi Space の会場・スタッフ手配の確認が必要です。1〜2営業日以内にご連絡いたします。',
    required: '*',
    successTitle: '予約申込が送信されました',
    successMessage: 'お申し込みありがとうございます！会場とスタッフの手配を確認後、できるだけ早くご連絡いたします。',
    backToHome: 'MuVi Space に戻る',
  },
  activityTypes: {
    podcast: 'Podcast 収録',
    livestream: 'ライブ配信',
    casting: 'キャスティング',
    brandInterview: 'ブランドインタビュー',
    productShooting: '商品撮影',
    courseRecording: '講座収録',
    other: 'その他',
  },
  admin: {
    bookings: {
      title: 'MuVi Space 予約管理',
      subtitle: 'すべての MuVi Space 予約申込を表示・管理',
      bookingId: '予約番号',
      customer: '顧客',
      date: '日付',
      time: '時間',
      activityType: '活動タイプ',
      estimatedAmount: '見積金額',
      status: 'ステータス',
      detail: '詳細を見る',
      history: '履歴',
      notes: '備考',
      statusPending: '保留中',
      statusStaffingReview: '人員審査中',
      statusConfirmed: '確認済み',
      statusRejected: '却下',
      statusCancelled: 'キャンセル',
      mockBanner: 'モックデータ — データベース未接続',
    },
    content: {
      title: 'MuVi Space コンテンツ管理',
      subtitle: 'フロントエンド表示コンテンツ、画像、セクション設定の管理',
      hero: 'ヒーローセクション',
      heroDesc: 'ヒーロー背景画像の管理',
      gallery: '施設写真管理',
      galleryDesc: '施設実景写真カルーセルの管理',
      equipmentImages: '機材画像管理',
      equipmentImagesDesc: '機材・サービスセクション画像の管理',
      features: '特徴ブロック管理',
      featuresDesc: '特徴カードの内容と並び順の管理',
      faq: 'FAQ 管理',
      faqDesc: 'よくある質問の内容管理',
      mockBanner: 'モックデータ — データベース未接続',
      save: '変更を保存',
      saved: '保存しました',
      addImage: '画像を追加',
      uploadImage: '画像をアップロード',
      imageUrl: '画像URL',
      altText: '代替テキスト',
      sortOrder: '並び順',
      active: '有効',
      inactive: '無効',
      delete: '削除',
      maxImages: '各セクション最大6枚',
    },
    settings: {
      title: 'MuVi Space 設定',
      subtitle: '予約関連設定と連絡先情報の管理',
      venueHourlyRate: '会場時給 (NT$)',
      techHourlyRate: '技術スタッフ時給 (NT$)',
      bookingNotice: '予約説明テキスト',
      bookingNoticePlaceholder: '予約ページに表示する説明テキストを入力...',
      contactPhone: '連絡先電話番号',
      contactEmail: '連絡先メールアドレス',
      googleMapEmbed: 'Google Maps 埋め込みURL',
      googleMapPlaceholder: 'Google Maps 埋め込み iframe URL を貼り付け...',
      saveSettings: '設定を保存',
      saved: '設定を保存しました',
      mockBanner: 'モックデータ — データベース未接続',
    },
  },
};
